import { DatasourcedWidgetMetadata } from '@/modules/ta/legacy/widget/models/metadata/DataSourcedWidgetMetadata';

export class TopPerformerWidgetMetadata extends DatasourcedWidgetMetadata {}
